import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../Context/AuthContext'; // Adjust path if needed
import Layout from '../components/Layout'; // Your layout component
import { Spinner } from 'react-bootstrap'; // Or any spinner you like

const ProtectedRoute = ({
  element,
  adminOnly = false,
  refugeeOnly = false,
  stateOnly = false,
}) => {
  const { user, loading } = useAuth();

  // Show Layout with spinner inside while loading
  if (loading) {
    return (
      <Layout>
        <div
          style={{
            minHeight: '60vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Spinner animation="border" variant="primary" />
        </div>
      </Layout>
    );
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }

  if (adminOnly && !user.isAdmin) {
    return <Navigate to="/" replace />;
  }

  if (refugeeOnly && !user.isRefugee) {
    return <Navigate to="/" replace />;
  }

  if (stateOnly && !user.isState) {
    return <Navigate to="/" replace />;
  }

  // User is authenticated and allowed to see this route
  return element;
};

export default ProtectedRoute;